import React, {useEffect, useRef} from 'react';
import {usePathname} from 'next/navigation';

import CSS from './Sidebar.module.scss';
import URLs from './URLs';
import Vector from '@/components/elements/vector/Vector';
import {useClickOut} from '@/hooks/click-out';

export default function Sidebar(props: {
  isOpen: boolean;
  setIsOpen: SetState<boolean>;
  activeDropDown: string;
  activeDropDownRef: React.ForwardedRef<HTMLUListElement>;
  onActiveDropDown: (dropDown: string) => void;
}) {
  const pathname = usePathname();
  const sidebarDownRef = useRef<HTMLDivElement>(null);

  // Closing the sidebar on navigation change
  useEffect(() => exit, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  // Closing the sidebar on outside click
  useClickOut(sidebarDownRef, props.isOpen, exit);

  function exit() {
    props.setIsOpen(false);
  }

  return (
    <div
      ref={sidebarDownRef}
      className={[CSS.sidebar, props.isOpen ? CSS.open : ''].join(' ')}>
      <Vector
        name="IoClose"
        className={[CSS.closeIcon, props.isOpen ? CSS.animate : ''].join(' ')}
        onClick={exit}
      />
      <URLs
        activeDropDown={props.activeDropDown}
        activeDropDownRef={props.activeDropDownRef}
        onActiveDropDown={props.onActiveDropDown}
        setIsSidebarOpen={props.setIsOpen}
        showIcons
        showSubIcons
      />
    </div>
  );
}
